import React from "react";
import { Link, useLocation } from "react-router-dom";
import { getMessage } from "../data/locales";
import {
  buildLegalDocumentLinkExtras,
  buildLegalDocumentTo,
  getLegalFlowReturn,
} from "../utils/legalFlowReturn";
import "./FooterPublico.css";

const FooterPublico = () => {
  const location = useLocation();
  const flowReturn = getLegalFlowReturn(location.pathname, location.search);
  const legalLinkExtras = buildLegalDocumentLinkExtras(flowReturn);
  const newTabTitle = flowReturn.openLinksInNewTab
    ? getMessage("legal.opensInNewTab")
    : undefined;

  return (
    <footer className="footer-publico">
      <div className="footer-contenido">
        <div className="footer-legal">
          <Link to={buildLegalDocumentTo("/terminos", flowReturn)} title={newTabTitle} {...legalLinkExtras}>
            {getMessage("legal.terms")}
          </Link>
          <span className="footer-legal-sep">|</span>
          <Link to={buildLegalDocumentTo("/privacidad", flowReturn)} title={newTabTitle} {...legalLinkExtras}>
            {getMessage("legal.privacy")}
          </Link>
        </div>
        <div className="footer-links">
        <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
            <img src="/assets/icons/facebook.png" alt="Facebook" className="social-icon ui-integrated-image" draggable="false" onContextMenu={(e) => e.preventDefault()} />
          </a>
          <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
            <img src="/assets/icons/instagram.png" alt="Instagram" className="social-icon ui-integrated-image" draggable="false" onContextMenu={(e) => e.preventDefault()} />
          </a>
          <a href="https://web.telegram.org/a/" target="_blank" rel="noopener noreferrer">
            <img src="/assets/icons/telegram.png" alt="Telegram" className="social-icon" />
          </a>
        </div>
        <div className="footer-container">
              <img
                className="footer-logo ui-integrated-image"
                src="/logos/LOGO_ACADEMIA.png"
                alt="Logo Academia"
                draggable="false"
                onContextMenu={(e) => e.preventDefault()}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                style={{ cursor: 'pointer' }}
              />
              <p className="footer-copy"> &copy; MarTestGo {new Date().getFullYear()}. Todos los derechos reservados.</p>
            </div>

      </div>
    </footer>
  );
};

export default FooterPublico;
